
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const purchaseService = {
  getVendorList,
  getVendorDetails,
  submitVendor,
  submitVendorAddress,
  submitVendorOtherInfo,
  getVendorNotification,
  saveVendorTableHeader,
  changeVendorStatus,
  deleteVendor,
  getBillsList,
  getBillDetails,
  setBillBulkAction,
  saveBillTableHeader,
  getBillEntryData,
  saveNewBill,
  getBillHistory,
  getPurchaseReceiveList,
  savePurchaseReceiveTableHeader,
  getPurchaseReceiveDetails,
  submitPurchaseReceive,
  convertBillToReceive,
  getBillsListByDate,
  searchBillData,
  searchPurchaseOrderData,
  getPurchaseOrderListByDate,
  vendorSearch,
  purchaseReceiveByDate,
  searchPurchaseReceiveSearch,
  billDetailsAction
};

async function  getVendorList() {
    return  apiClient.get(`/purchases/get-vendor-list`, authHeader());
}

async function  getVendorDetails(vendor_id) {
    return  apiClient.get(`/purchases/get-vendor-details/${vendor_id}`, authHeader());
}

async function  submitVendor(data) {
    return  apiClient.post(`/purchases/submit-vendor`,data, authHeader());
}

async function  vendorSearch(searchText) {
    return apiClient.get(`/purchases/vendor-search?search=${searchText}`, authHeader());
}



async function  submitVendorAddress(data) {
    return  apiClient.post(`/purchases/submit-vendor-address`,data, authHeader());
}

async function  submitVendorOtherInfo(data) {
    return  apiClient.post(`/purchases/submit-vendor-other-info`,data, authHeader());
}


async function  getVendorNotification(vendor_id) {
    return  apiClient.get(`/purchases/get-vendor-notification/${vendor_id}`, authHeader());
}



async function  deleteVendor(vendor_id) {
    return  apiClient.delete(`/purchases/delete-vendor/${vendor_id}`, authHeader());
}

async function  saveVendorTableHeader(body) {
    return  apiClient.post(`/purchases/save-vendor-table-header`, body, authHeader());
}

async function  changeVendorStatus(body) {
    return  apiClient.put(`/purchases/change-vendor-status`, body, authHeader());
}

async function  getBillsList() {
    return  apiClient.get(`/purchases/bills-list`, authHeader());
}

async function  getBillsListByDate(dateForm) {
    return  apiClient.post(`/purchases/bills-list-by-date`,dateForm, authHeader());
}

async function  searchBillData(searchText) {
    return  apiClient.get(`/purchases/bills-search?search=${searchText}`, authHeader());
}

async function  getBillDetails(bill_id) {
    return  apiClient.get(`/purchases/bill-details/${bill_id}`, authHeader());
}

async function  setBillBulkAction(body) {
    return  apiClient.put(`/purchases/set-bill-bulk-action`, body, authHeader());
}

async function  billDetailsAction(body) {
    return  apiClient.put(`/purchases/bill-details-action`, body, authHeader());
}

async function  saveBillTableHeader(body) {
    return  apiClient.post(`/purchases/save-bill-table-header`, body, authHeader());
}


async function  getBillEntryData() {
    return  apiClient.get(`/purchases/bill-entry-data`, authHeader());
}



async function  saveNewBill(body) {
    return  apiClient.post(`/purchases/save-bill-record`, body, authHeader());
}

async function  getBillHistory(id) {
    return  apiClient.get(`/purchases/bill-history/${id}`, authHeader());
}

async function  getPurchaseReceiveList() {
    return  apiClient.get(`/purchases/purchase-receive-list`, authHeader());
}

async function  purchaseReceiveByDate(form) {
    return apiClient.post(`/purchases/purchase-receive-by-date`, form, authHeader());
}


async function  getPurchaseOrderListByDate(dateForm) {
    return  apiClient.post(`/accounts/purchase-order-by-date`,dateForm, authHeader());
}

async function  searchPurchaseOrderData(searchText) {
    return  apiClient.get(`/accounts/purchase-order-search?search=${searchText}`, authHeader());
}


async function  savePurchaseReceiveTableHeader(body) {
    return  apiClient.post(`/purchases/purchase-receive-save-table-column`, body, authHeader());
}

async function  getPurchaseReceiveDetails(purchase_id) {
    return  apiClient.get(`/purchases/purchase-receives-details/${purchase_id}`, authHeader());
}


async function  submitPurchaseReceive(form) {
    return  apiClient.post(`/purchases/submit-purchase-receive`, form, authHeader());
}

async function  convertBillToReceive(form) {
    return  apiClient.post(`/purchases/convert-to-bill`, form, authHeader());
}

async function searchPurchaseReceiveSearch(searchText) {
  return apiClient.get(`/purchases/purchase-receive-search?search=${searchText}`, authHeader());
}














